<template>
  <div>
    <div class="d-flex justify-end" v-if="isExcelExportShown">
      <DiligenceReportExcelExport class="my-4" :params="filters" />
    </div>
    <v-data-table
      :headers="headers"
      :items="diligences"
      item-key="id"
      :server-items-length="studentCount"
      :options.sync="tableOptions"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
      disable-sort
    >
      <!-- Học sinh -->
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template v-slot:[`item.dob`]="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | ddmmyyyy }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="item.status === 'present' || item.status === 'absent'">
          <div class="pt-2" style="height: 36px"></div>
        </div>
        <div v-else>
          <v-chip small label :color="item.status | getDiligenceStatusColor">
            <span>
              {{ item.status | getDiligenceStatus }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.present`]="{ item }">
        <div v-if="item.present">
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#00C853'" dark>
              <span> Có mặt</span>
            </v-chip>
          </div>
        </div>
        <div v-else-if="item.status === 'absent'">
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#FF9800'" dark>
              <span> Vắng mặt</span>
            </v-chip>
          </div>
        </div>
        <div v-else>
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#FBC02D'">
              <span>Vắng mặt</span>
            </v-chip>
          </div>
        </div>
      </template>
      <template v-slot:[`item.class`]="{ item }">
        {{ item | _get('class.title') }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DiligenceReportExcelExport from './DiligenceReportExcelExport.vue'
import { Diligence } from '@/plugins/api'
import moment from 'moment'

const defaultHeaders = [
  { text: 'Học sinh', value: 'student' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Lớp', value: 'class' },
  { text: 'Ngày học', value: 'date' },
  { text: 'Trạng thái', value: 'present' },
  { text: 'CP/KP/Đi muộn', value: 'status' }
]
export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 10
      },
      selectedDiligence: null,
      addDiligence: false,
      studentSearchParams: {},
      diligences: [],
      studentCount: 0,
      loading: false,
      dialog: false
    }
  },
  props: {
    filters: Object
  },
  components: {
    CardStudentName,
    DiligenceReportExcelExport
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentCount)
      }
      if (this.studentCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    },
    isExcelExportShown() {
      if (!this.filters) return false
      const diff = moment(this.filters.date_lte).diff(moment(this.filters.date_gte), 'days')
      return diff < 2
    }
  },
  methods: {
    ...mapActions('Diligence', ['fetchDiligences']),

    async searchStudentDiligences() {
      this.$loading.active = true
      this.loading = true
      // New filter
      if (this.filters) {
        await Diligence.count(this.filters)
          .then(response => {
            this.studentCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng học sinh')
          })
      }
      try {
        this.diligences = await Diligence.fetch({ ...this.filters, ...this.pageSetting() })
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
      }
      this.loading = false
      this.$loading.active = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: ['gradeNumber:ASC', 'className:ASC', 'nameToNumber:ASC'].join(',')
      }
    },
    openDialog(item) {
      this.selectedDiligence = item
      this.$nextTick(() => {
        this.dialog = !this.dialog
      })
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudentDiligences()
        }
      },
      deep: true
    },
    filters: {
      handler(newOptions) {
        if (newOptions) {
          this.tableOptions.page = 1
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
